import React from 'react';

import Admin from '~/layouts/Admin';

const Home: React.FC = () => {
  return <Admin />;
};

export default Home;
